import { Controller } from "@hotwired/stimulus"
import { DomHelper } from "../utils/dom"

export default class extends Controller {
  static targets = ["input", "feedback"]

  validate() {
    const value = this.inputTarget.value
    const katakanaRegex = /^[ァ-ヶー\s]*$/

    if (value && !katakanaRegex.test(value)) {
      DomHelper.showValidationError(this.inputTarget, this.feedbackTarget, "カタカナで入力してください")
    } else if (value) {
      DomHelper.showValidationSuccess(this.inputTarget, this.feedbackTarget)
    } else {
      DomHelper.clearValidation(this.inputTarget, this.feedbackTarget)
    }
  }
}
